/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Sales_OrdersInputs */

const en_nav_sales_orders = /** @type {(inputs: Nav_Sales_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sales orders`)
};

/**
* | output |
* | --- |
* | "Sales orders" |
*
* @param {Nav_Sales_OrdersInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_sales_orders = /** @type {((inputs?: Nav_Sales_OrdersInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Sales_OrdersInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_sales_orders(inputs)
});